import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { DatePipe } from '../../../../shared/pipe/date.pipe'
import { ActivityManagementService } from '../../activity-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-manage-consult',
  templateUrl: './manage-consult.component.html',
  styleUrls: ['./manage-consult.component.scss']
})
export class ManageConsultComponent implements OnInit {
  dateForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private activityManagementService: ActivityManagementService,
    private gobalFunctionService: GobalFunctionService
  ) {
    this.dateForm = this.fb.group({
      date: [''],
    })
  }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('การจัดการ Consult');

    if (!window.history.state['consult-uid']) {
      this.router.navigate(['activity-management/consult']);
    }
  }

  add(date) {
    let now = new Date();
    let d = new Date(date).setHours(now.getHours());
    let n = new Date();
    n.setDate(n.getDate() + 2);

    if (date > n) {
      this.router.navigate(['../add'], { relativeTo: this.route, state: { 'consult-date': d.toString(), 'consult-uid': window.history.state['consult-uid'] } });
    } else {
      n.setDate(n.getDate() + 1)
      n.setHours(0, 0, 0)
      alert(`สามารถเพิ่มช่วงเวลาได้ตั้งแต่วันที่  ${new DatePipe().transform(n.toString(), 'full')} กรุณาลองใหม่อีกครั้ง`)
    }
  }

  duplicate(date) {
    let now = new Date();
    let d = new Date(date).setHours(now.getHours());
    let n = new Date();
    n.setDate(n.getDate() + 2);

    const body = {
      USER_ID: window.history.state['consult-uid'],
      CONSULT_DATE: d
    }

    this.activityManagementService.getDetailConsultByDate(body).pipe(
      map(res => {
        let countcheck = res.result.filter(el => el.CONSULT_STATUS !== 'empty')

        if (date > n && countcheck.length === 0) {
          this.router.navigate(['../duplicate'], { relativeTo: this.route, state: { 'consult-date': d.toString(), 'consult-uid': window.history.state['consult-uid'] } });
        } else {
          if (date < n) {
            let afterDay = new Date(n.setDate(n.getDate() + 1))
            afterDay.setHours(0, 0, 0)
            alert(`สามารถเพิ่มช่วงเวลาได้ตั้งแต่วันที่  ${new DatePipe().transform(afterDay.toString(), 'full')} กรุณาลองใหม่อีกครั้ง`)
          }
          if (date > n && countcheck.length > 0) {
            alert(`ไม่สามารถ Duplicate วันที่ ${new DatePipe().transform(new Date(d).toString(), 'full')} เนื่องจากมีการสร้าง Consult แล้ว กรุณาลองใหม่อีกครั้ง`)
          }
        }
      })
    ).subscribe();
  }
}
